import { Z_EMAIL, Z_FIRST_NAME, Z_LAST_NAME, Z_PHONE } from '@common/schemas';
import { z } from 'zod';

export const createEditOfaUtilisateurFormSchemaWithAsyncEmail = (
  emailAsyncValidation: (email: string) => Promise<boolean>,
) =>
  z.object({
    nom: Z_LAST_NAME,
    prenom: Z_FIRST_NAME,
    email: Z_EMAIL.refine(
      async (email) => {
        return await emailAsyncValidation(email);
      },
      {
        message: 'Cette adresse email est déjà utilisée',
      },
    ),
    telephone: Z_PHONE,
  });

export const editOfaUtilisateurFormSchema = z.object({
  nom: Z_LAST_NAME,
  prenom: Z_FIRST_NAME,
  email: Z_EMAIL,
  telephone: Z_PHONE,
});

export type EditOfaUtilisateurFormResult = z.infer<typeof editOfaUtilisateurFormSchema>